var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"imgLarge",class:{'show': _vm.shown}},[_c('video',{ref:"video",attrs:{"playsinline":"","loop":"","muted":"","autoplay":"","src":_vm.media.url,"crossorigin":"anonymous","preload":"auto"},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }